import {
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';

import LoginPage from './pages/LoginPage';
import HomePage from './pages/HomePage';
import { ProtectedRoute } from './functions/ProtectedRoute';
import {AppLayoutSideBar} from './components/AppLayoutSideBar';
import ProfilePage from './pages/ProfilePage';
// import ClientsPage  from './pages/ClientsPage';
// import PlanificationsPage from './pages/PlanificationsPage';
// import AnalysisPage from './pages/AnalysisPage';
import UsersManagement from './pages/UsersManagement';
import RolesManagement from './pages/RolesManagement';
import RoleGuard from './functions/RoleGuard';
import ChatPage from "./pages/ChatPage";

export default function AppRoutes() {
    return (
    <Routes>
        {/* 1) Login fuera del layout  ---------------------------------------- */}
        <Route path="/login" element={<LoginPage />} />

        {/* 2) Zona protegida bajo /  (basename aporta “/app”)  --------------- */}
        <Route
            element={
                <ProtectedRoute>
                    <AppLayoutSideBar />
                </ProtectedRoute>
            }
        >
            {/* Landing: /app */}
            <Route index element={<HomePage />} />

            {/* Páginas encuestas */}
            {/* <Route element={<RoleGuard allowedRoles={['crm', 'admin']} />}>
                <Route path="clientes" element={<ClientsPage />} />
            </Route> */}

            {/* Página perfil */}
            <Route path="perfil" element={<ProfilePage />} />

            <Route path="chat" element={<ChatPage />} />
            <Route path="chat/:uuid_thread" element={<ChatPage />} />

            {/* <Route element={<RoleGuard allowedRoles={['planification', 'admin']} />}>
                <Route path="planificaciones" element={<PlanificationsPage />} />
            </Route>

            <Route element={<RoleGuard allowedRoles={['analysis', 'admin']} />}>
                <Route path="analiticas" element={<AnalysisPage />} />
            </Route> */}

            {/* Sólo puede entrar si tiene el rol admin */}
            <Route element={<RoleGuard allowedRoles="admin" />}>
                <Route path="admin/users" element={<UsersManagement />} />
                <Route path="admin/roles" element={<RolesManagement />} />
            </Route>
        </Route>

        {/* Cualquier otra ruta: al login */}
        <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
    );
}
